<div class="monty-action-card" *ngIf="action">
	<span class="monty-glyph"><span class="material-symbols-outlined">person_raised_hand</span></span>
	<span class="monty-action-desc">
		{{ 'MONTY.action_' + action.type | translate | capitalize }}
		<ng-container *ngIf="action.type !== 'REMOVE_FROM_FLIGHT' && action.alternatives?.length; else plainLabel">
			<a class="monty-flight" [matMenuTriggerFor]="flightMenu" [matTooltip]="'MONTY.action_repick' | translate | capitalize">{{
				flightLabel
			}}</a>
			<mat-menu #flightMenu="matMenu">
				<button mat-menu-item (click)="pick({ flightId: action.flightId, label: action.label })">{{ action.label }}</button>
				<button mat-menu-item *ngFor="let option of action.alternatives" (click)="pick(option)">{{ option.label }}</button>
			</mat-menu>
		</ng-container>
		<ng-template #plainLabel>
			<span class="monty-flight-plain">{{ flightLabel }}</span>
		</ng-template>
	</span>
	<span class="monty-failure" *ngIf="failureReason && !hideFailure">{{ 'MONTY.failure_' + failureReason | translate | capitalize }}</span>
	<button mat-flat-button color="primary" class="monty-accept" [disabled]="busy" (click)="onAccept()">
		{{ 'MONTY.accept' | translate | capitalize }}
	</button>
	<button mat-icon-button class="monty-dismiss" [disabled]="busy" (click)="dismiss.emit()" [matTooltip]="'MONTY.dismiss' | translate | capitalize">
		<mat-icon>close</mat-icon>
	</button>
</div>
